import { FolderForestTreeType } from 'owa-favorites-types';
import { Folder } from 'owa-folders';
import { isFolderUnderArchiveRoot } from 'owa-mail-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { isDeletedItemsFolderFromAnyMailbox, isDumpsterFolderFromAnyMailbox } from 'owa-mail-store';
import {
    PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID,
    ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID,
} from 'owa-folders';

export interface EmptyFolderHelperProperties {
    deletedItemsFolderId: string;
    isFolderDeletedItemsFolder: boolean;
    isFolderDumpsterFolder: boolean;
    shouldSupportBulkActions: boolean;
    treeType: FolderForestTreeType;
}

/**
 * Get properties required for completing empty folder action
 * @param folder the folder to be emptied
 */
export default function getEmptyFolderHelperProperties(
    folder: Folder
): EmptyFolderHelperProperties {
    if (!folder) {
        throw new Error('Folder should not be null at getEmptyFolderHelperProperties');
    }

    const emptyFolderHelperProperties = <EmptyFolderHelperProperties>{};

    const isFolderUnderArchiveMbx = isFolderUnderArchiveRoot(folder.FolderId.Id);

    if (isFolderUnderArchiveMbx) {
        // Bulk actions notifications (or any kind of notification) are not supported for folder from Archive MBX
        emptyFolderHelperProperties.shouldSupportBulkActions = false;
        emptyFolderHelperProperties.treeType = 'archiveFolderTree';
        emptyFolderHelperProperties.deletedItemsFolderId = folderNameToId(
            ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID
        );
    } else {
        emptyFolderHelperProperties.shouldSupportBulkActions = true;
        emptyFolderHelperProperties.treeType = 'primaryFolderTree';
        emptyFolderHelperProperties.deletedItemsFolderId = folderNameToId(
            PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID
        );
    }

    emptyFolderHelperProperties.isFolderDeletedItemsFolder = isDeletedItemsFolderFromAnyMailbox(
        folder.FolderId.Id
    );

    emptyFolderHelperProperties.isFolderDumpsterFolder = isDumpsterFolderFromAnyMailbox(
        folder.FolderId.Id
    );

    return emptyFolderHelperProperties;
}
